// import parseISO from 'date-fns/parseISO';
import { GET_WAREHOUSE_DATA, UI_START_LOADING, UI_STOP_LOADING } from '../actions/types';

const initialState = () => {
  return {
    list: [],
    isLoading: false
  };
};

export default function(state = initialState(), action = {}) {
  switch (action.type) {
    case GET_WAREHOUSE_DATA: {
      return { ...state, ...{ list: action.data } };
    }
    case UI_START_LOADING: {
      return { ...state, isLoading: true };
    }
    case UI_STOP_LOADING: {
      return { ...state, isLoading: false };
    }
    default:
      return state;
  }
}
